export default {
    showAddNewPaymentModal() {
        toggleLoader()
        $('#add-new-payment-type-modal').modal('show')
        this.$events.emit('resetModalCreate');
        toggleLoader(false)
    },
    editPaymentTypeModal(paymentTypeID) {
        $('#edit-payment-type-modal').modal('show');
        this.$events.emit('displayEditModal', paymentTypeID);
    },
    deletePaymentTypeSwal(paymentTypeID)
    {
        swal({
            title: $.i18n._("delete_payment_type?"),
            text: $.i18n._("it_will_be_impossible_to_restore_it!"),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: $.i18n._("delete"),
            cancelButtonText: $.i18n._("cancel"),
            closeOnConfirm: true
        }, function () {
            $("#hidden-payment-type-id").val(paymentTypeID);
            $("#payment-type-delete-form").submit();
        });
    }
}
